export default __webpack_public_path__ + "static/media/shopping-bag.70521709.svg";